// extracted by mini-css-extract-plugin
export default {"meal_control_wrapper":"MealControl_meal_control_wrapper__4koxO","meal_control_wrapper_noActive":"MealControl_meal_control_wrapper_noActive__9Wsri"};